/** iter411 pt 1 → iter412 — icônes Trésorerie plates (2-3 tons, aucun dégradé), viewBox 40×40, rendues en 40 px comme la barre Commercial (iter411 écart).
 *  Toutes les icônes occupent la même surface (dessin inscrit dans 4..36). Tableau de bord et Configuration : inchangés (C1). */
import { IcoTableauDeBord, IcoConfiguration as IcoConfigCrm } from "@/components/crm/CrmIcons";

const Svg = ({ size = 30, style, children, ...rest }) => (
  <svg viewBox="0 0 40 40" width={size} height={size} aria-hidden="true" focusable="false" shapeRendering="geometricPrecision" style={{ flexShrink: 0, display: "block", ...style }} {...rest}>{children}</svg>
);

const Safe = ({ x = 4, y = 4, w = 32, h = 28, dial = 6, handle = false }) => (<>
  <rect x={x} y={y} width={w} height={h} rx="3" fill="#6B7787" />
  <rect x={x + 3} y={y + 3} width={w - 6} height={h - 6} rx="2" fill="#95A2B2" />
  <circle cx={x + w / 2} cy={y + h / 2} r={dial} fill="#2B6CE0" />
  <circle cx={x + w / 2} cy={y + h / 2} r={dial * 0.42} fill="#DCEBFF" />
  <rect x={x + 4} y={y + h} width="5" height="4" rx="1" fill="#6B7787" />
  <rect x={x + w - 9} y={y + h} width="5" height="4" rx="1" fill="#6B7787" />
  {handle && <rect x={x + w - 7} y={y + h / 2 - 3} width="2.2" height="6" rx="1" fill="#3F4854" />}
</>);


export const IcoComptes = (p) => <Svg {...p}><Safe /></Svg>;

export const IcoEcheances = (p) => <Svg {...p}>
  <rect x="9" y="4" width="18" height="4" rx="1.5" fill="#9A6A12" />
  <rect x="9" y="32" width="18" height="4" rx="1.5" fill="#9A6A12" />
  <path d="M11 8h14c0 6-4 9-7 12 3 3 7 6 7 12H11c0-6 4-9 7-12-3-3-7-6-7-12Z" fill="#F5C518" />
  <path d="M14 30h8c0-3-2.5-5-4-6.5-1.5 1.5-4 3.5-4 6.5Z" fill="#9A6A12" />
  <rect x="24" y="22" width="13" height="14" rx="2" fill="#E8ECF2" />
  <path d="M24 24a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v3H24Z" fill="#EF4444" />
  <text x="30.5" y="34.2" textAnchor="middle" fontSize="7.5" fontWeight="700" fontFamily="Tahoma, sans-serif" fill="#0B0F14">15</text>
</Svg>;

// iter412 — F1 : deux flèches en trait (épaisseur ≈ 11 % = 4.4/40), bouts et angles arrondis, écartées et décalées.
export const IcoMouvements = (p) => <Svg {...p}>
  <path d="M12 30V7M5.5 13.5 12 7l6.5 6.5" fill="none" stroke="#22C55E" strokeWidth="4.4" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M28 10v23M21.5 26.5 28 33l6.5-6.5" fill="none" stroke="#EF4444" strokeWidth="4.4" strokeLinecap="round" strokeLinejoin="round" />
</Svg>;

// iter412 — W5 : grand portefeuille brun, billet vert qui dépasse, pastille détourée (anneau couleur de la barre #101013).
const Wallet = () => (<>
  <rect x="11" y="4" width="14" height="12" rx="1.5" fill="#13A10E" />
  <rect x="13" y="6" width="10" height="8" rx="1" fill="#54C04F" />
  <rect x="4" y="10" width="32" height="26" rx="4" fill="#8B4513" />
  <rect x="4" y="10" width="32" height="7" rx="3.5" fill="#B5652B" />
  <path d="M22 20h14v10H22a4 4 0 0 1-4-4v-2a4 4 0 0 1 4-4Z" fill="#D48A4A" />
  <circle cx="26" cy="25" r="2.2" fill="#5A2A08" />
</>);
export const IcoEncaissements = (p) => <Svg {...p}>
  <Wallet />
  <circle cx="30.5" cy="30.5" r="8" fill="#16A34A" stroke="#101013" strokeWidth="2.4" />
  <path d="M30.5 26.5v8M26.5 30.5h8" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" />
</Svg>;
export const IcoDecaissements = (p) => <Svg {...p}>
  <Wallet />
  <circle cx="30.5" cy="30.5" r="8" fill="#DC2626" stroke="#101013" strokeWidth="2.4" />
  <path d="M26.5 30.5h8" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" />
</Svg>;

// iter412 — K5 : entonnoir (contour #475569, intérieur #1E293B), goulot rempli de vert, trois pièces dorées en haut.
export const IcoAlimentations = (p) => <Svg {...p}>
  <path d="M5 5h30a2.5 2.5 0 0 1 2 4L25 23v10.5a2.5 2.5 0 0 1-2.5 2.5h-5a2.5 2.5 0 0 1-2.5-2.5V23L3 9a2.5 2.5 0 0 1 2-4Z" fill="#475569" />
  <path d="M8.5 8h23L22.5 21.5V33h-5V21.5Z" fill="#1E293B" />
  <path d="M17.5 22.5h5V33h-5Z" fill="#22C55E" />
  <circle cx="13" cy="13" r="3.2" fill="#F5C518" stroke="#E0A10E" strokeWidth="1" /><circle cx="20" cy="11.5" r="3.2" fill="#F5C518" stroke="#E0A10E" strokeWidth="1" /><circle cx="27" cy="13" r="3.2" fill="#F5C518" stroke="#E0A10E" strokeWidth="1" />
</Svg>;

// iter412 — T8 : deux coffres (même dessin que Comptes, ≈ 55 %) en escalier, flèche courbe orange en trait du bas vers le haut, pointe à droite.
export const IcoTransferts = (p) => <Svg {...p}>
  <Safe x={2} y={18} w={20} h={15} dial={4.5} handle />
  <Safe x={18} y={2} w={20} h={15} dial={4.5} handle />
  <path d="M11 16.5C11 10 12.5 8 16 8" fill="none" stroke="#F97316" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M13 4.8 16.4 8 13 11.2" fill="none" stroke="#F97316" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
</Svg>;

// iter412 — R9 : fente en haut, un grand billet vertical qui en sort, flèche bleue en trait vers le bas.
export const IcoRetraits = (p) => <Svg {...p}>
  <rect x="4" y="3" width="32" height="9" rx="2.5" fill="#4B5563" />
  <rect x="8" y="6.5" width="24" height="2.6" rx="1.3" fill="#0B0F14" />
  <rect x="12" y="8" width="16" height="17" rx="1.5" fill="#13A10E" />
  <rect x="14" y="10" width="12" height="13" rx="1" fill="#54C04F" />
  <circle cx="20" cy="16.5" r="3.4" fill="#0B6A0B" /><circle cx="20" cy="16.5" r="1.6" fill="#B8F5D2" />
  <path d="M20 27v9M15.5 31.5 20 36l4.5-4.5" fill="none" stroke="#3B9EFF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
</Svg>;

export const IcoDashboard = (p) => <IcoTableauDeBord size={30} {...p} />;
export const IcoConfiguration = (p) => <IcoConfigCrm size={30} {...p} />;
